import React from "react";
import PropTypes from "prop-types";
import { Link, NavLink } from "react-router-dom";
import classNames from "classnames";
import i18n from "i18next";

const LinkBase = (props) => {
  //    console.log(props)

  const addLangToLink = (dest) => {
    if (i18n.language === "en") return dest;
    const m = dest.match(/^([^?#]*)(.*)$/);
    const pathOnly = m[1];
    const queryHash = m[2];
    const linkPath = pathOnly.split("/");
    linkPath.splice(1, 0, i18n.language);
    return linkPath.join("/") + queryHash;
  };

  const renderInner = () => {
    return props.children;
  };

  const renderLink = (props) => {
    const { to, state, className, blank, isUnderline, hash, ...rest } = props;
    const full = addLangToLink(to);
    const qIdx = full.indexOf("?");
    const pathname = qIdx === -1 ? full : full.slice(0, qIdx);
    const search = qIdx === -1 ? "" : full.slice(qIdx);

    return (
      <Link
        {...rest}
        target={blank ? "_blank" : undefined}
        className={classNames([
          "link link-to",
          className,
          isUnderline && "isUnderline",
        ])}
        to={{ pathname, search, state, hash }}
      >
        {renderInner()}
      </Link>
    );
  };

  const renderNavLink = (props) => {
    const { to, state, className, activeClassName, blank, isNavLink, ...rest } =
      props;

    return (
      <NavLink
        {...rest}
        className={classNames(["link link-to", className])}
        to={{ pathname: addLangToLink(to), state: state }}
        exact={true}
        activeClassName={activeClassName}
      >
        {renderInner()}
      </NavLink>
    );
  };

  const renderHref = (props) => {
    const { href, blank, rel, className, label, isUnderline } = props;

    //console.log(props)

    return (
      <a
        className={classNames([
          "link link-href",
          className,
          isUnderline && "isUnderline",
        ])}
        href={href}
        target={blank ? "_blank" : ""}
        rel={rel ? "noopener noreferrer" : ""}
        aria-label={label}
      >
        {renderInner()}
      </a>
    );
  };

  const renderSpan = (props) => {
    const { className, isUnderline, onClick } = props;

    return (
      <span
        onClick={onClick}
        className={classNames([
          "link link-span",
          className,
          isUnderline && "isUnderline",
        ])}
      >
        {renderInner()}
      </span>
    );
  };

  if (props.to !== "" && !props.isNavLink) {
    return renderLink(props);
  } else if (props.to !== "" && props.isNavLink) {
    return renderNavLink(props);
  } else if (props.href !== "") {
    return renderHref(props);
  } else {
    return renderSpan(props);
  }
};

LinkBase.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
  blank: PropTypes.bool,
  content: PropTypes.string,
  state: PropTypes.object,
  className: PropTypes.string,
  label: PropTypes.string,
};

LinkBase.defaultProps = {
  to: "",
  href: "",
  blank: true,
  content: "",
  state: {},
  className: "",
  label: "",
};
export default React.memo(LinkBase);
